// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';
import App from './App.js';
import ErrorBoundary from './components/ErrorBoundary.js';
import reportWebVitals from './reportWebVitals.js';

// ---------- Lazy chunk auto-recovery (prevents "stuck Loading…" after deploys)
let __reloadedForChunk = false;
const isChunkError = (msg) =>
  /Loading chunk \d+ failed|ChunkLoadError/i.test(String(msg || ''));

// Reload once with a cache-busting param if a lazy chunk fails to load
window.addEventListener('error', (e) => {
  if (!__reloadedForChunk && isChunkError(e?.message)) {
    __reloadedForChunk = true;
    const u = new URL(window.location.href);
    u.searchParams.set('v', Date.now().toString());
    window.location.replace(u.toString());
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e?.reason?.message || e?.reason;
  if (!__reloadedForChunk && isChunkError(msg)) {
    __reloadedForChunk = true;
    const u = new URL(window.location.href);
    u.searchParams.set('v', Date.now().toString());
    window.location.replace(u.toString());
  }
});
// ---------------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

const app = (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Render (StrictMode only in dev)
root.render(
  process.env.NODE_ENV === 'development'
    ? <React.StrictMode>{app}</React.StrictMode>
    : app
);

/**
 * Service Worker handling
 * - Unregister ALL existing service workers immediately (avoid stale caches)
 * - Only register a new SW if REACT_APP_ENABLE_SW=true
 */
if ('serviceWorker' in navigator) {
  // Ensure no old SW controls this build
  navigator.serviceWorker.getRegistrations?.().then((regs) => {
    regs.forEach((r) => r.unregister());
  });

  // Optional registration gated by env var
  window.addEventListener('load', () => {
    const enableSW = String(process.env.REACT_APP_ENABLE_SW || '').toLowerCase() === 'true';
    if (!enableSW) return;
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(() => console.log('✅ Service Worker Registered'))
      .catch((error) => console.error('❌ Service Worker Registration Failed:', error));
  });
}

// Web vitals: log in development only
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
}
